import axios from "axios";

const useRevenue = () => {
  const env = process.env.REACT_APP_ENV || "development";

  const baseURLMapping = {
    production: process.env.REACT_APP_BASE_URL_PRODUCTION,
    staging: process.env.REACT_APP_BASE_URL_STAGING,
    development: process.env.REACT_APP_BASE_URL_DEV, // Default to dev
  };

  const baseURL = `${baseURLMapping[env] || process.env.REACT_APP_BASE_URL_DEV}/revenue`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("access")}`,
  };

  const axiosInstance = axios.create({
    baseURL,
    headers,
  });

  const getRevenueKPIs = async (params) => {
    return await axiosInstance.get("/faturamento/get_kpis/", {
      params: params,
    });
  };

  const getRevenueCollections = async () => {
    return await axiosInstance.get("/colecoes/get_collections/");
  };

  const getStores = async () => {
    return await axiosInstance.get("/faturamento/get_stores/");
  };

  const getAggregatedSales = async (params) => {
    return await axiosInstance.get("/faturamento/get_aggregated_sales/", {
      params: params,
    });
  };

  const getCollectionsZonesRevenue = async (params) => {
    return await axiosInstance.get("/faturamento/get_collections_revenue/", {
      params: params,
    });
  };

  return {
    getRevenueKPIs,
    getRevenueCollections,
    getStores,
    getAggregatedSales,
    getCollectionsZonesRevenue,
  };
};

export default useRevenue;
